import React from "react";
import PropTypes from "prop-types";

import BlackStars0 from "../../../../../public/images/black-stars-0.svg";
import BlackStars1 from "../../../../../public/images/black-stars-1.svg";
import BlackStars2 from "../../../../../public/images/black-stars-2.svg";
import BlackStars3 from "../../../../../public/images/black-stars-3.svg";
import BlackStars4 from "../../../../../public/images/black-stars-4.svg";
import BlackStars5 from "../../../../../public/images/black-stars-5.svg";
import BlackStars6 from "../../../../../public/images/black-stars-6.svg";
import BlackStars7 from "../../../../../public/images/black-stars-7.svg";
import BlackStars8 from "../../../../../public/images/black-stars-8.svg";
import BlackStars9 from "../../../../../public/images/black-stars-9.svg";
import BlackStars10 from "../../../../../public/images/black-stars-10.svg";

export default function ReviewStars({ imageName }) {
  const starSvgMapping = {
    BlackStars0,
    BlackStars1,
    BlackStars2,
    BlackStars3,
    BlackStars4,
    BlackStars5,
    BlackStars6,
    BlackStars7,
    BlackStars8,
    BlackStars9,
    BlackStars10,
  };

  const Component = starSvgMapping[imageName];

  return (
    <div className="flex w-28 h-5 mb-0.5" data-test-id={imageName}>
      <Component />
    </div>
  );
}

ReviewStars.propTypes = {
  imageName: PropTypes.string.isRequired,
};
